export default "__VITE_ASSET__hdAfaFoQ__"